// GstinModel.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import './App.css'; // Import the CSS file
import { Button } from 'react-bootstrap';
import Typography from '@mui/material/Typography';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import CancelIcon from '@mui/icons-material/Cancel';
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { Spin,notification } from 'antd';
import { DatePicker, Input, Tag, message } from "antd";
// import CreateForm from '../GSTCreds/CreateForm';


const GstinModel = ({ isOpen, onClose, workspaceId, workspaceName }) => {
  const [rowData, setRowData] = useState([]);
  const [localStatuses, setLocalStatuses] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedPAN, setSelectedPAN] = useState([
    "37AAFCR9951H1ZV",
    "23AAACH3235M2ZQ",
  ]);
  const [token, setToken] = useState(null);


  useEffect(() => {
    const savedToken = sessionStorage.getItem('token');
    if (savedToken) {
      setToken(savedToken);
    }
    if (isOpen && workspaceId) {
      // Fetch GSTIN workspace data
      axios.get(`https://stage-apiplatform.finkraft.ai/api/meta/gstin/workspace/${workspaceId}`)
        .then(response => {
          const workspaceData = response.data.data;

          // Fetch GST credentials
          axios.get('https://apiplatform.finkraft.ai/cred/gst/get/all')
            .then(credResponse => {
              const credentials = credResponse.data.credentials;

              // Map and merge credential data with workspace data
              const combinedData = workspaceData.map(workspaceItem => {
                const matchedCred = credentials.find(cred => cred.gstin === workspaceItem.gstin);
                return {
                  ...workspaceItem,
                  gst_cred_username: matchedCred?.gst_cred_username || null,
                  gst_cred_status: matchedCred?.gst_cred_status || null,
                  last_ran: matchedCred?.last_ran || null,
                };
              });

              // Set row data and initialize local statuses
              setRowData(combinedData);
              const statuses = {};
              combinedData.forEach(row => {
                statuses[row.gstin] = row.is_active || false; // Assuming 'is_active' is the status field
              });
              setLocalStatuses(statuses);
            })
            .catch(error => {
              console.error('Error fetching credentials:', error);
            });
        })
        .catch(error => {
          console.error('Error fetching GSTINs:', error);
        });
    }
  }, [isOpen, workspaceId]);

  const handleCheckboxChange = (gstin) => {
    setLocalStatuses(prev => {
      const newStatuses = { ...prev, [gstin]: !prev[gstin] };
      // Update rowData with new statuses
      setRowData(prevData => prevData.map(row => 
        row.gstin === gstin ? { ...row, is_active: newStatuses[gstin] } : row
      ));
      return newStatuses;
    });
  };

  const updateGstinStatus = (gstin) => {
    const status = localStatuses[gstin];
    axios.post('https://stage-apiplatform.finkraft.ai/api/meta/update_gstin_status', {
      gstin,
      status
    },
    {
      headers: {
          'Authorization': `Bearer ${token}`
      }
    })
      .then(response => {
        alert(`Status updated successfully to: ${status}`);
      })
      .catch(error => {
        console.error('There was an error updating the status!', error);
      });
  };

  const columnDefs = [
    { headerName: 'GSTIN', field: 'gstin', sortable: true, filter: true, minWidth: 200,enableRowGroup: true },
    { headerName: 'Entity Name', field: 'entity_name', sortable: true, filter: true, minWidth: 200,enableRowGroup: true },
    { headerName: 'PAN', field: 'pan', sortable: true, filter: true, minWidth: 200,enableRowGroup: true },
    {
      headerName: 'Is Active',
      field: 'is_active',
      minWidth: 200,
      enableRowGroup: true,
      cellRenderer: params => {
        const gstin = params.data ? params.data.gstin : null;
        return (
          <input
            type="checkbox"
            checked={localStatuses[gstin] || false}
            onChange={() => gstin && handleCheckboxChange(gstin)}
          />
        );
      },
    },
    
    { headerName: "Created At", field: "created_at", minWidth: 200,enableRowGroup: true },
    {
      headerName: 'Action',
      minWidth: 200,
      enableRowGroup: true,
      cellRenderer: params => {
        const gstin = params.data ? params.data.gstin : null;
        return (
          <button
            onClick={() => gstin && updateGstinStatus(gstin)}
            className="save-button"
          >
            Save
          </button>
        );
      },
    },
    {
      headerName: "Username",
      field: "gst_cred_username",
      enableRowGroup: true,
      minWidth: 200,
      cellRenderer: params => {
        const username = params.data?.gst_cred_username || 'N/A';
        return <span>{username}</span>;
      },
    },
    
    {
      headerName: "Gst Cred Status",
      enableRowGroup: true,
      field: "gst_cred_status",
      enableRowGroup: true,
      minWidth: 200,
      cellRenderer: params => {
        const statusData = params.data?.gst_cred_status || params.node.key;
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography>{statusData}</Typography>
            {statusData === "ACTIVE" ? (
              <FiberManualRecordIcon style={{ fontSize: 18, color: "#2ecc71", marginLeft: 4 }} />
            ) : statusData === "PENDING" ? (
              <Spin style={{ marginLeft: 4 }} size="small" />
            ) : (
              <CancelIcon style={{ fontSize: 18, color: "#e74c3c", marginLeft: 4 }} />
            )}
          </div>
        );
      },
    },
    {
      headerName: "Last Job Ran",
      field: "last_ran",
      enableRowGroup: true,
      enableRowGroup: true,
      minWidth: 200,
    },
    {
      field: "sync",
      headerName: "Job Sync",
      enableRowGroup: true,
      minWidth: 200,
      cellRenderer: (params) => {
        return params?.data?.status === "PENDING" ||
           (
          <div
            style={{ display: "flex", alignItems: "center", height: "100%" }}
          >
            <Tag
              color="blue"
              style={{ cursor: "pointer" }}
              onClick={() => handleJobSync(params?.data)}
            >
              Sync Now
            </Tag>
          </div>
        );
      },
    },
    {
      field: "validate",
      headerName: "Validate",
      enableRowGroup: true,
      minWidth: 200,
      cellRenderer: (params) => {
        return (
          <button
           className='validate-btn'
            onClick={() => handleValidate(params?.data?.gstin)}
          >
            Validate
          </button>
        );
      },
    },
    {
      field: "action",
      headerName: "Edit",
      enableRowGroup: true,
      cellRenderer: (params) => {
        return (
          <div>
            <EditRoundedIcon
              style={{
                fontSize: 20,
                cursor: "pointer",
                opacity: params?.data?.status === "ACTIVE" ? 0.5 : 1,
                pointerEvents:
                  params?.data?.status === "ACTIVE" ? "none" : "auto",
              }}
              onClick={() => handleEditCred(params.data)}
            />
          </div>
        );
      },
    },
  ];

  const handleValidate = async (gstin) => {
    setLoading(true); // Set loading state to true when validation starts
  
    try {
      // First, call the backend to get credentials
      const response = await fetch('https://stage-apiplatform.finkraft.ai/api/meta/validategst', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ gstin }),
      });
  
      if (!response.ok) {
        throw new Error('Failed to retrieve credentials');
      }
  
      const result = await response.json();
  
      // Check the status and extract username and password if successful
      if (result.status) {
        const { username, password } = result.data; // Extract username and password from data
        console.log('Username:', username);
        console.log('Password:', password);
  
        // Now call the external API with the retrieved credentials
        const loginResponse = await fetch('https://scraper-apis.finkraftai.com/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',

          },
          body: JSON.stringify({ username, password }),
        });
  
        // Handle different response statuses
        if (loginResponse.status === 200) {
          notification.success({
            message: 'Success',
            description: `Credentials are valid for GSTIN: ${gstin}`,
          });
          // Update the status in the database to "ACTIVE"
          await updateStatusInDatabase(gstin, 'ACTIVE');
        } else if (loginResponse.status === 400) {
          notification.error({
            message: 'Error',
            description: `Invalid credentials for GSTIN: ${gstin}.`,
          });
          // Update the status in the database to "INVALID"
          await updateStatusInDatabase(gstin, 'INVALID');
        } else if (loginResponse.status === 500) {
          notification.error({
            message: 'Error',
            description: 'Server error occurred while validating the GSTIN.',
          });
        } else {
          // Handle unexpected response status
          notification.error({
            message: 'Error',
            description: 'An unexpected error occurred. Please try again.',
          });
        }
      } else {
        console.error('Error:', result.code);
        notification.error({
          message: 'Error',
          description: result.code || 'An error occurred while retrieving credentials.',
        });
      }
    } catch (error) {
      console.error('Error:', error);
      notification.error({
        message: 'Error',
        description: 'An error occurred while validating the GSTIN.',
      });
    } finally {
      setLoading(false); // Reset loading state
    }
  };
  
  
  // Function to update the status in the database
  const updateStatusInDatabase = async (gstin, status) => {
    try {
      const updateResponse = await fetch('https://stage-apiplatform.finkraft.ai/api/meta/updatecredStatus', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ gstin, status }), // Send the new status
      });
  
      if (!updateResponse.ok) {
        console.error('Failed to update status in the database.');
      }
  
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  

  const handleJobSync = async (payloadObj) => {
    console.log("payload object is:", payloadObj);
    const response = await axios
      .post("https://apiplatform.finkraft.ai/cred/gst/sync", payloadObj)
      .then((response) => {
        messageApi.open({
          type: "success",
          content: "Credential Sync Started",
        });
        setShowDialog("");
      });
  };

  const [popupData, setPopupData] = useState({
    gstin: "",
    username: "",
    password: "",
  });

  const [showDialog, setShowDialog] = useState("");
  const [messageApi, contextHolder] = message.useMessage();


  const updateGSTCred = async () => {
    const payload = {
      id: popupData?.id,
      gstin: popupData?.gstin,
      username: popupData?.username,
      password: popupData?.password,
    };
    const response = await axios
      .post("https://apiplatform.finkraft.ai/cred/gst/update", payload)
      .then((response) => {
        messageApi.open({
          type: "success",
          content: "Credentials updated",
        });
        // fetchAPIData();
        setShowDialog("");
      });
  };
  const handleSaveCreds = async () => {
    const payload = [
      {
        gstin: popupData?.gstin,
        username: popupData?.username,
        password: popupData?.password,
      },
    ];
    const response = await axios
      .post("https://apiplatform.finkraft.ai/cred/gst/add", payload)
      .then((response) => {
        messageApi.open({
          type: "success",
          content: "Credential created",
        });
        setSelectedPAN([...selectedPAN, popupData.gstin]);
        // fetchAPIData();
        setShowDialog("");
      });
  };





  const handleEditCred = (data) => {
    setPopupData({
      id: data?.id,
      username: data?.username,
      password: data?.password,
      gstin: data?.gstin,
    });
    setShowDialog("EDIT");
  };

  return (
    isOpen && (
      <div className="gstin-modal">
        <div>
          <button className="close-button" onClick={onClose}>
            X
          </button>
          <h5>GSTINs for Workspace : {workspaceName}</h5>
  
          {/* Main Grid/Table for GSTINs */}
          <div className="ag-theme-alpine" style={{ height: 400, width: "100%" }}>
            {rowData.length > 0 ? (
              <AgGridReact
                rowData={rowData}
                columnDefs={columnDefs}
                rowGroupPanelShow='always'
                defaultColDef={{ flex: 1, resizable: true }}
              />
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <span>No GSTINs available</span>
              </div>
            )}
          </div>
  
          {/* Blocking overlay when loading is true */}
          {loading && (
            <>
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(255, 255, 255, 0.7)', // Slightly transparent
                  zIndex: 1000, // Above the modal content
                  cursor: 'not-allowed', // Indicate non-clickable
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  zIndex: 2000, // Above the overlay
                }}
              >
                <Spin size="large" />
              </div>
            </>
          )}
  
          {/* Conditional Rendering of Overlaying Edit Dialog */}
          {showDialog === "EDIT" && (
            <div
              className="edit-dialog-overlay"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)", // Transparent background
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 2000, // Above other elements
              }}
            >
              <div
                className="edit-dialog"
                style={{
                  backgroundColor: "#fff",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                  width: "400px",
                }}
              >
                <div style={{ marginBottom: 24, width: "100%" }}>
                  <Input
                    placeholder="Username"
                    variant="filled"
                    style={{ width: "100%" }}
                    onChange={(e) =>
                      setPopupData({ ...popupData, username: e.target.value })
                    }
                    defaultValue={popupData?.username || ""}
                  />
                </div>
  
                <div style={{ marginBottom: 24, width: "100%" }}>
                  <Input
                    placeholder="Password"
                    variant="filled"
                    style={{ width: "100%" }}
                    onChange={(e) =>
                      setPopupData({ ...popupData, password: e.target.value })
                    }
                    defaultValue={popupData?.password || ""}
                  />
                </div>
  
                <div className="actionContainer">
                  <Button
                    variant="contained"
                    onClick={popupData.id ? updateGSTCred : handleSaveCreds}
                    style={{ marginRight: 12 }}
                  >
                    Save
                  </Button>
                  <Button variant="contained" onClick={() => setShowDialog("")}>
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  );
  
   
};

export default GstinModel;
